import type { Drawing, Stroke } from '../../shared/art/types';

/** The streamed mirror half is part of the same hand gesture and the same undo step. */
export function continuesMirror(drawing: Drawing, stroke: Stroke) {
  const previous = drawing.strokes.at(-1);
  if (!previous || previous.tool === 'eraser' || stroke.tool === 'eraser' || previous.brush !== 'mirror' || stroke.brush !== 'mirror') return false;
  const a = previous.points[0]; const b = stroke.points[0];
  return a.t === b.t && Math.abs(a.x + b.x - 1000) < 0.001 && a.y === b.y && previous.color === stroke.color && previous.width === stroke.width;
}
